import { DisbursementMethod, EmployeeRole } from 'types';

/* HTTP Status Codes  */
export enum HTTPStatusCode {
  PARTIAL_CONTENT = '206',
  UNAUTHORIZED = '401',
  NOT_FOUND = '404',
  CONFLICT = '409',
  UNPROCESSABLE_ENTITY = '422',
}

/* Org Admin Default Job Title */
export const DEFAULT_ORG_ADMIN_JOB_TITLE = 'org admin';

/* Toast Message */
export const GENERIC_TOAST_ERROR_MESSAGE = 'Sorry, an unexpected error occurred. If this problem continues, please contact Kickfin Support.';

/* Oauth Key for Connecting an Integration */
export const CONNECT_OAUTH_KEY = 'integration_oauth_state';

/* State Abbreviations */
export const STATE_ABVS: string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'AS',
  'GU',
  'MP',
  'PR',
  'VI',
  'FM',
  'MH',
  'PW',
  'AA',
  'AE',
  'AP',
];

/* Dropdown option type */
export type DDOption = { value: any; label: string };

/* Site Role Options */
export const SiteRoleOptions: Array<DDOption> = [
  { value: EmployeeRole.SITE_ADMIN, label: 'Site Admin' },
  { value: EmployeeRole.MANAGER, label: 'Manager' },
  { value: EmployeeRole.EMPLOYEE, label: 'Employee' },
];

/* Admin Role Options */
export const AdminRoleOptions: Array<DDOption> = [{ value: 'admin', label: 'Organization Admin' }];

/* User Role Options */
export const UserRoleOptions: Array<DDOption> = [...AdminRoleOptions, ...SiteRoleOptions];

/* Dismiss Reason Options */
export const DismissReasons: Array<DDOption> = [
  { label: 'Seasonal Worker', value: 'Seasonal Worker' },
  { label: 'Site Transfer', value: 'Site Transfer' },
  { label: 'Staff Reduction', value: 'Staff Reduction' },
  { label: 'Employment Ended', value: 'Employment Ended' },
  { label: 'Other', value: 'Other' },
];

/* Disbursement Method Options */
export const DisbursementOptions: Array<DDOption> = [
  { label: 'Instant', value: DisbursementMethod.INSTANT },
  { label: 'Payroll', value: DisbursementMethod.PAYROLL },
];
